import { getMopaAd } from '../../api/ad'

export default {
  namespaced: true,
  state: {
    ads: {}
  },
  // mutations 修改器，用于修改state中的定义的状态变量,同步
  mutations: {
    setAds(state, payload) {
      const { pageAds, code } = payload
      state.ads = {
        ...state.ads,
        [code]: {
          ...state.ads[code],
          ...pageAds
        }
      }
    }
  },
  // 存放异步操作，由 action 去触发 mutation
  actions: {
    async getAd({ state, commit }, { code, cCodes, vipLevel, equipment }) {
      const { ads } = state
      const pageAds = ads[code] || {}
      if (pageAds[cCodes]) {
        return pageAds[cCodes]
      }
      let res
      try {
        res = await getMopaAd({ code, cCodes }, vipLevel, equipment)
      } catch (e) {
        res = []
      }
      pageAds[cCodes] = res
      commit('setAds', {
        pageAds,
        code
      })
      return res
    }
  }
}
